import { marker } from '@jsverse/transloco-keys-manager/marker';

export const DEFAULT_SADM_ENTITY_NAME_KEY = marker('Nouvelle lésion, Non localisée');
